import React, { useEffect, useState } from 'react';
import * as IndicadoresTitulo from '../constantes/IndicadoresTitulosEquipos.js';
import { NombreEquipoTorneo } from '../funciones/FuncionesEquipo';
import IconoTitulo from '../UI/IconoTitulo';
import LinkPlus from '../UI/LinkPlus.js';
import useGetListaURL from '../../hooks/useGetListaURL';
import styles from './UltimoTorneoTipo.module.css';

const UltimoTorneoTipo = (props) => {
  const torneo = props.torneo;
  const [campeon, setCampeon] = useState(null);
  const { fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const obtenerCampeon = (lista) => {
      const listaFiltrada = lista.filter(
        (item) =>
          item.tituloObtenido === IndicadoresTitulo.CAMPEON ||
          item.tituloObtenido === IndicadoresTitulo.MEDALLA_ORO
      );
      if (listaFiltrada && listaFiltrada.length > 0) {
        setCampeon(listaFiltrada[0]);
      } else {
        setCampeon(null);
      }
    };

    if (torneo) {
      fetchData('torneos/' + torneo.id + '/participantes?conTituloObtenido=true', obtenerCampeon);
    } else {
      setCampeon(null);
    }
  }, [torneo, fetchData]);

  return (
    <React.Fragment>
      {torneo && (
        <LinkPlus className={`${styles.nombreTorneo}`} to={'/torneos/' + torneo.id}>
          {torneo.descripcion}
        </LinkPlus>
      )}
      <div className={`${styles.campeon}`}>
        {campeon && campeon.equipo && (
          <React.Fragment>
            {NombreEquipoTorneo(campeon.equipo, torneo)}
            <IconoTitulo objeto={campeon} />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default UltimoTorneoTipo;
